import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";

import DataGrid, { Column, Pager, Paging, FilterRow, HeaderFilter, GroupPanel, Grouping, Selection, Export } from "devextreme-react/data-grid";
import { MoneyMask } from "src/util/Masks/MoneyMask";
import { PercentageMask } from "src/util/Masks/PercentageMask";
import { useContext } from "react";
import { AuthContext } from "src/components/context/AuthContext";

function TradesTable(
  props: {
    style?: React.CSSProperties;
    data: any[];
    loading?: boolean;
    refresh: () => void;
  } & RouteComponentProps<any>
) {
  const { currentUser } = useContext(AuthContext);

  const moneyMask = (params: any) => MoneyMask(params.value!);
  return (
    <>
      <DataGrid
        dataSource={props.data}
        allowColumnReordering
        showBorders
        loadPanel={{ enabled: props.loading }}
        rowAlternationEnabled
        hoverStateEnabled
        columnAutoWidth
      >
        <GroupPanel visible />
        <Grouping autoExpandAll />
        <Selection mode={"multiple"} selectAllMode showCheckBoxesMode />
        <FilterRow visible />
        <HeaderFilter visible />
        <Column caption="Id Trade" alignment={"center"} dataField="id" dataType="number" width={"100px"} />
        <Column caption="Data de Criação" alignment={"center"} dataField="createdDate" dataType="date" format={"dd/MM/yyyy"} />
        <Column caption="Status" alignment={"center"} dataField="status" dataType="string" />
        <Column caption="Fase" alignment={"center"} dataField="phase" dataType="string" />
        <Column caption="Usuário" alignment={"center"} dataField="fullname" dataType="string" />
        <Column caption="Tipo" alignment={"center"} dataField="courtType" dataType="string" />
        <Column caption="Tribunal" alignment={"center"} dataField="courtName" dataType="string" />
        <Column caption="Processo" alignment={"center"} dataField="processCode" dataType="string" />
        <Column caption="Requerente" alignment={"center"} dataField="requester" dataType="string" />
        <Column caption="CPF/CNPJ" alignment={"center"} dataField="cpfCnpj" dataType="string" />
        <Column caption="Correção" dataField="correctionTypeName" dataType="string" alignment={"center"} />
        <Column caption="PSS" alignment={"center"} dataField="isPss" dataType="boolean" />
        <Column caption="Preço" alignment={"center"} dataField="price" dataType="number" cellRender={moneyMask} />
        <Column caption="Percentual do Credor" alignment={"center"} dataField="reducedPercentLender" dataType="number" cellRender={params => {
          return PercentageMask(params.data.reducedPercentLender, 2, 2);
        }}
        />
        <Column caption="Principal" alignment={"center"} dataField="principal" dataType="number" cellRender={moneyMask} />
        <Column caption="Juros" alignment={"center"} dataField="interest" dataType="number" cellRender={moneyMask} />

        <Column caption="Comissão" alignment={"center"} dataField="commissionValue" dataType="number" visible={currentUser.permissions.userCanSeeCommission}
          cellRender={moneyMask}
        />
        <Column caption="% Comissão" alignment={"center"} dataField="commissionPercentage" dataType="number" visible={currentUser.permissions.userCanSeeCommission}
          customizeText={function (cellInfo) { return `${PercentageMask(cellInfo.value, 2, 2)}` }}
        />

        <Column caption="Data Base" alignment={"center"} dataField="baseDate" dataType="date" format={"dd/MM/yyyy"} />
        <Column caption="Data Emissao" alignment={"center"} dataField="issueDate" dataType="date" format={"dd/MM/yyyy"} />
        <Column caption="Data Desembolso" alignment={"center"} dataField="disbursementDate" dataType="date" format={"dd/MM/yyyy"} />
        <Column caption="Data de Vencimento" alignment={"center"} dataField="maturityDate" dataType="date" format={"dd/MM/yyyy"} />
        <Pager allowedPageSizes={[10, 25, 50, 100]} showPageSizeSelector />
        <Paging defaultPageSize={10} />
        <Export enabled fileName={"Trades"} excelFilterEnabled allowExportSelectedData />
      </DataGrid>
    </>
  );
}

export default withRouter(TradesTable);



// WEBPACK FOOTER //
// ./src/pages/gerencial/operacoes/trades/TradesTable.tsx